import * as React from 'react';
import styled from 'styled-components';

type TContainerChild = React.ReactChild | undefined;

export interface IContainerProps {
	className?: string;
	children?: TContainerChild[] | TContainerChild;

	// RENDER OPTIONS
	aligned?: 'left' | 'center' | 'right';
	fullWidth?: true;
	renderChildrenInline?: true;
}

const ContainerComponent = (props: IContainerProps) => {
	return <div className={props.className}>{props.children}</div>;
};

export const Container = styled(ContainerComponent)`
	${ContainerCss}
`;

function ContainerCss(props: IContainerProps): any {
	return `${props.aligned !== undefined ? `text-align: ${props.aligned};` : ''}
	${props.fullWidth !== undefined ? 'width: 100%;' : ''}
	${
		props.renderChildrenInline !== undefined
			? `
		& > * {
			display: inline-block;
		};
	`
			: ''
	}`;
}
